import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const onePasswordUsers = defineConnector({
  identifier: "onePasswordUsers",
  name: "1Password Users",
  tagLine: "Manage 1Password users via OAuth",
  logo,
  protocol: "http",
  tags: ["security", "identity"],
  defaultUrlPattern: ({ apiHost }) => domainToRegex(apiHost),
  auth: oauthAuth,
  steps: [
    {
      title: "Create a 1Password OAuth application",
      items: [
        {
          kind: "markdown",
          content: `1. In 1Password, open **Integrations → OAuth Application**.
2. Fill in the application name, description, and a redirect URL (any URL works for client credentials, e.g. \`https://example.com\`).
3. Select these scopes: **Get User**, **List Users**, **Suspend User**, **Reactivate User**.
4. Click **Generate Credentials** and copy the **Client ID** and **Client Secret**.`,
        },
      ],
    },
    {
      title: "Enter your 1Password OAuth details",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "apiHost" },
          options: [
            { value: "https://api.1password.com", label: "US" },
            { value: "https://api.1password.eu", label: "EU" },
            { value: "https://api.1password.ca", label: "Canada" },
          ],
          helperText: "The region where your 1Password account is hosted.",
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
          helperText:
            "Your 1Password account ID, used to scope Users API requests.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ apiHost }) => `${apiHost}/v1beta1/users/oauth2/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => ["openid"],
  },
  connectionTest: {
    protocol: "http",
    request: ({ apiHost, accountId }) => ({
      url: `${apiHost}/v1beta1/accounts/${accountId}/users?max_page_size=1`,
      headers: { "User-Agent": "3B-Connector" },
    }),
  },
});
